export const entries = [
  {
    id: "shen-jiamu-jucan",
    title: "沈嘉木深夜聚餐风波汇总",
    persona: "沈嘉木",
    category: "entertainment",
    tags: ["深夜聚餐", "片场关系", "工作室回应"],
    summary:
      "演员沈嘉木被路人拍到与剧组同事深夜聚餐，画面在社交平台快速传播。本页按时间顺序整理话题发酵过程、工作室说明与同组演员的表态。",
    heat: 9821,
    date: "2026-08-13",
    updated: "2026-08-22",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20night%20city%20bokeh%20with%20warm%20amber%20lights%20and%20soft%20grain%2C%20editorial%20magazine%20cover%20texture%2C%20muted%20vermilion%20and%20cream%20palette%2C%20minimal%20artistic%20composition&width=800&height=600&seq=entry-shenjiamu-01&orientation=landscape&nocache=true",
    body: [
      "8 月 13 日晚，一段街边餐厅外的路人拍摄视频开始在社交平台流传，画面中沈嘉木与数名剧组成员同桌用餐，因拍摄时间较晚，话题词条在当晚冲上讨论榜。",
      "争议主要集中在两点：一是聚餐是否影响到第二天的拍摄进度，二是同桌人员中有此前被传关系紧张的合作方。截至发稿，两组说法都没有片场排班表或公开行程作为佐证。",
      "8 月 15 日，沈嘉木工作室发布了一段不足百字的说明，表示当天为剧组收工后的常规会餐，次日拍摄按计划进行，并请网友不要过度解读同行之间的正常往来。",
      "8 月 18 日，同组演员在个人账号发布了一张多人合照的局部，配文提到「剧组氛围一直不错」，被普遍视为侧面回应。此后话题热度逐步回落。",
      "整理提示：本条汇总仅梳理公开可见的讨论脉络，涉及私人关系与工作安排的判断目前均无确证，建议以官方通告为准。",
    ],
    timeline: [
      { date: "2026-08-13", text: "路人拍摄视频流出，话题词条进入讨论榜前列" },
      { date: "2026-08-14", text: "多个娱乐账号转发，讨论集中在聚餐时间与合作方关系" },
      { date: "2026-08-15", text: "沈嘉木工作室发布简短说明，称系收工会餐" },
      { date: "2026-08-18", text: "同组演员发布合照局部，被解读为侧面回应" },
      { date: "2026-08-22", text: "话题热度回落，无新增官方信息" },
    ],
    related: ["su-wantang-kouwu", "gu-yu-fanwei", "pei-qinghe-juben"],
  },
  {
    id: "lin-su-luyin",
    title: "林溯新歌录音花絮争议汇总",
    persona: "林溯",
    category: "music",
    tags: ["录音花絮", "修音讨论", "制作人回应"],
    summary:
      "歌手林溯新单曲发布后，一段未公开的录音室花絮被剪成短视频传播，围绕现场演唱与后期处理的讨论持续数日。本页汇总双方说法与制作团队回应。",
    heat: 8734,
    date: "2026-07-28",
    updated: "2026-08-05",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20recording%20studio%20atmosphere%20with%20amber%20light%20streaks%20and%20blurred%20waveform%20shapes%2C%20warm%20cream%20and%20deep%20red%20tones%2C%20editorial%20magazine%20texture%2C%20minimal%20artistic&width=800&height=600&seq=entry-linsu-01&orientation=landscape&nocache=true",
    body: [
      "7 月 28 日，新单曲上线首日，一段标注为「录音室花絮」的短视频被多个账号转发，内容为林溯在棚内反复演唱某个高音段落。",
      "部分听众据此讨论歌曲成品是否经过大量后期处理，也有现场乐手在评论区表示，棚内反复录制属于常规工作流程，与成品质量没有直接关系。",
      "8 月 1 日，制作人在个人账号回应称，花絮片段拍摄于正式录制之前的试音阶段，成品中人声处理在行业常规范围内，并晒出了部分工程截图。",
      "8 月 5 日，林溯本人在演出结束后被问到此事，仅表示「欢迎大家去现场听」，未进一步展开。话题随后转入对现场演出票务的讨论。",
    ],
    timeline: [
      { date: "2026-07-28", text: "新单曲上线，录音室花絮视频开始传播" },
      { date: "2026-07-30", text: "现场乐手在评论区说明棚内录制流程" },
      { date: "2026-08-01", text: "制作人发文回应并公开部分工程截图" },
      { date: "2026-08-05", text: "林溯演出后被问及此事，未正面展开" },
    ],
    related: ["chi-ye-chaoxi", "jiang-yubai-shuju", "shen-jiamu-jucan"],
  },
  {
    id: "su-wantang-kouwu",
    title: "苏晚棠直播口误事件汇总",
    persona: "苏晚棠",
    category: "screen",
    tags: ["直播口误", "切片传播", "公开道歉"],
    summary:
      "主持人苏晚棠在一档直播节目的互动环节出现口误，相关切片被二次剪辑后传播，引发对节目流程与主持人状态的讨论。本页整理事件经过与致歉内容。",
    heat: 9465,
    date: "2026-08-02",
    updated: "2026-08-09",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20broadcast%20studio%20spotlight%20on%20empty%20stage%20with%20warm%20amber%20beam%20and%20soft%20haze%2C%20cream%20and%20vermilion%20color%20palette%2C%20editorial%20magazine%20texture%2C%20minimal&width=800&height=600&seq=entry-suwantang-01&orientation=landscape&nocache=true",
    body: [
      "8 月 2 日晚，苏晚棠在直播节目的嘉宾介绍环节读错了一处名称，现场随即自行更正。原始直播时段内并未引起大范围讨论。",
      "次日，一段掐头去尾的切片被剪辑后传播，配上了与原节目无关的字幕，导致部分观众对当时情境产生误解。",
      "8 月 4 日，节目组发布说明，公布了完整片段，并指出切片存在二次剪辑。苏晚棠随后在个人账号转发该说明，简短写道「是我的问题，已和对方沟通致歉」。",
      "8 月 9 日，当事嘉宾在活动中被问及此事，表示已收到道歉，不希望继续扩大讨论。事件基本告一段落。",
    ],
    timeline: [
      { date: "2026-08-02", text: "直播现场出现口误，主持人当场更正" },
      { date: "2026-08-03", text: "二次剪辑切片开始传播，引发误解" },
      { date: "2026-08-04", text: "节目组公布完整片段，苏晚棠转发并致歉" },
      { date: "2026-08-09", text: "当事嘉宾回应已收到道歉，希望降温" },
    ],
    related: ["shen-jiamu-jucan", "bai-luchuan-zhibo", "wen-zhi-peiyin"],
  },
  {
    id: "gu-yu-fanwei",
    title: "顾屿新片番位之争汇总",
    persona: "顾屿",
    category: "screen",
    tags: ["番位之争", "海报排序", "片方说明"],
    summary:
      "导演顾屿新片的定档海报发布后，演员署名顺序引发讨论，两家粉丝在评论区出现持续争论。本页整理海报版本变化与片方回应。",
    heat: 8102,
    date: "2026-07-15",
    updated: "2026-07-24",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20cinema%20marquee%20lights%20at%20dusk%20with%20warm%20amber%20glow%20and%20deep%20red%20accents%2C%20cream%20paper%20texture%2C%20editorial%20magazine%20artistic%20minimal%20composition&width=800&height=600&seq=entry-guyu-01&orientation=landscape&nocache=true",
    body: [
      "7 月 15 日，顾屿新片发布定档海报，两位主演的名字采用上下排布。有观众发现不同平台的海报版本中，署名的上下顺序并不一致。",
      "由此引出的讨论迅速从海报延伸到预告片字幕、路演站位等细节，双方粉丝各自整理「证据图」进行比对。",
      "7 月 20 日，片方发布统一说明，称署名顺序按合同约定的方式执行，各平台物料为不同批次制作，已启动统一替换。",
      "7 月 24 日，多个票务平台完成海报更新，讨论热度明显下降。顾屿本人在路演中未就此事单独回应。",
    ],
    timeline: [
      { date: "2026-07-15", text: "定档海报发布，署名排布引发注意" },
      { date: "2026-07-17", text: "各平台海报版本不一致被整理对比" },
      { date: "2026-07-20", text: "片方说明署名按合同执行，将统一物料" },
      { date: "2026-07-24", text: "票务平台完成海报替换，讨论降温" },
    ],
    related: ["pei-qinghe-juben", "wen-zhi-peiyin", "shen-jiamu-jucan"],
  },
  {
    id: "jiang-yubai-shuju",
    title: "江予白赛事数据争议汇总",
    persona: "江予白",
    category: "sports",
    tags: ["赛事数据", "判罚争议", "官方通报"],
    summary:
      "电竞选手江予白在一场关键比赛中的数据被指异常，赛后裁判组与赛事官方先后给出说明。本页按时间线梳理争议焦点与结论。",
    heat: 7743,
    date: "2026-06-30",
    updated: "2026-07-08",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20esports%20arena%20with%20amber%20and%20deep%20red%20stage%20lighting%2C%20blurred%20screens%20and%20geometric%20shapes%2C%20cream%20paper%20texture%2C%20editorial%20minimal%20artistic&width=800&height=600&seq=entry-jiangyubai-01&orientation=landscape&nocache=true",
    body: [
      "6 月 30 日，一场季后赛结束后，有观众指出江予白在第三局的若干关键决策与平时习惯差异明显，相关讨论当天在社区快速扩散。",
      "7 月 1 日，战队发布说明，表示选手当天存在身体不适，战术执行出现偏差，但不存在任何违规行为。",
      "7 月 3 日，赛事官方公布了对局数据核查结果，确认未发现操作异常，判罚维持原结果，同时提醒观众理性看待赛场波动。",
      "7 月 8 日，江予白在赛后采访中提到已经调整状态，并感谢队伍的支持。此后讨论转为对下一轮赛程的预测。",
    ],
    timeline: [
      { date: "2026-06-30", text: "第三局关键决策被指异常，社区讨论升温" },
      { date: "2026-07-01", text: "战队说明选手身体不适，否认违规" },
      { date: "2026-07-03", text: "赛事官方公布数据核查结果，判罚维持" },
      { date: "2026-07-08", text: "江予白赛后回应状态已调整" },
    ],
    related: ["shang-yiran-tuoyi", "lin-su-luyin", "shen-jiamu-jucan"],
  },
  {
    id: "lu-shiyan-daiyan",
    title: "陆时衍品牌代言风波汇总",
    persona: "陆时衍",
    category: "business",
    tags: ["品牌代言", "合作调整", "双方声明"],
    summary:
      "时尚博主陆时衍与某服饰品牌的合作形式发生变化，双方先后发布声明，就合约期限与内容范围给出了不同表述。本页汇总两份声明的差异点。",
    heat: 6980,
    date: "2026-07-04",
    updated: "2026-07-12",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20fashion%20showroom%20with%20hanging%20fabric%20and%20warm%20amber%20light%2C%20cream%20and%20deep%20red%20palette%2C%20editorial%20magazine%20texture%2C%20minimal%20artistic%20composition&width=800&height=600&seq=entry-lushiyan-01&orientation=landscape&nocache=true",
    body: [
      "7 月 4 日，有网友发现陆时衍近两个月的合作内容中已不再出现该服饰品牌，随即有账号称双方「合作终止」。",
      "7 月 6 日，品牌方先发布声明，称合作按计划进入阶段性的间隔期，并未终止，并感谢对方的专业配合。",
      "同日稍晚，陆时衍工作室发布自己的版本，表述为「合约到期后不再续约」，与品牌方的说法存在明显差异。",
      "7 月 12 日，双方均未再就此发声。商业观察类账号普遍认为，两份声明的差异可能来源于对「间隔期」的不同理解，目前已无进一步信息。",
    ],
    timeline: [
      { date: "2026-07-04", text: "网友发现合作内容消失，终止传闻出现" },
      { date: "2026-07-06", text: "品牌方声明称进入阶段性间隔期" },
      { date: "2026-07-06", text: "陆时衍工作室声明称到期不再续约" },
      { date: "2026-07-12", text: "双方均未再发声，讨论趋于平静" },
    ],
    related: ["han-sinan-jieyue", "bai-luchuan-zhibo", "lin-su-luyin"],
  },
  {
    id: "shang-yiran-tuoyi",
    title: "商亦然赛后退赛争议汇总",
    persona: "商亦然",
    category: "sports",
    tags: ["退赛", "伤病说明", "赛事通报"],
    summary:
      "运动员商亦然在一场分站赛中于中途退出，围绕退赛时机与原因的讨论持续数日。本页整理医疗说明、赛事通报与本人回应。",
    heat: 6412,
    date: "2026-06-18",
    updated: "2026-06-27",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20running%20track%20ground%20at%20sunset%20with%20warm%20amber%20light%20and%20long%20shadows%2C%20cream%20paper%20texture%2C%20editorial%20magazine%20minimal%20artistic&width=800&height=600&seq=entry-shangyiran-01&orientation=landscape&nocache=true",
    body: [
      "6 月 18 日，分站赛中段，商亦然在完成一次加速后示意退出，裁判随即终止其比赛进程。现场观众对退赛时机议论较多。",
      "6 月 19 日，队伍发布医疗说明，称选手在赛前已有旧伤反应，热身阶段出现不适，出于保护决定退出。",
      "6 月 21 日，赛事官方通报确认收到队伍的医疗申报，并说明退赛程序符合规程，成绩按规则处理。",
      "6 月 27 日，商亦然在康复训练后接受采访，表示目前恢复情况良好，具体复出时间以队伍公告为准。",
    ],
    timeline: [
      { date: "2026-06-18", text: "比赛中途示意退出，现场议论较多" },
      { date: "2026-06-19", text: "队伍发布医疗说明，称系旧伤反应" },
      { date: "2026-06-21", text: "赛事官方通报退赛程序符合规程" },
      { date: "2026-06-27", text: "商亦然回应恢复良好，复出时间待公告" },
    ],
    related: ["jiang-yubai-shuju", "gu-yu-fanwei", "chi-ye-chaoxi"],
  },
  {
    id: "chi-ye-chaoxi",
    title: "迟野单曲旋律相似争议汇总",
    persona: "迟野",
    category: "music",
    tags: ["旋律相似", "版权说明", "创作者回应"],
    summary:
      "说唱歌手迟野的新单曲上线后，有创作者指出副歌旋律与一首旧作存在相似之处。本页梳理双方比对过程与版权方说明。",
    heat: 7205,
    date: "2026-07-21",
    updated: "2026-07-30",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20vinyl%20record%20and%20sound%20wave%20pattern%20with%20amber%20and%20deep%20red%20accents%2C%20cream%20paper%20background%2C%20editorial%20magazine%20texture%2C%20minimal%20artistic&width=800&height=600&seq=entry-chiye-01&orientation=landscape&nocache=true",
    body: [
      "7 月 21 日，新单曲上线，一位独立创作者在社交平台发布了两段音频的对比视频，指出副歌部分存在较高的旋律相似度。",
      "7 月 23 日，迟野的制作团队回应称，创作过程中参考了同一时期的音乐风格，但谱面并不构成实质性相似，并愿意接受第三方比对。",
      "7 月 26 日，旧作的版权代理方发布声明，表示已启动内部评估，在结论明确前暂不发表进一步评论。",
      "7 月 30 日，双方均未公布评估结果，单曲仍可正常收听。本条汇总将持续跟进后续进展。",
    ],
    timeline: [
      { date: "2026-07-21", text: "新单曲上线，对比视频出现" },
      { date: "2026-07-23", text: "制作团队回应认为不构成实质性相似" },
      { date: "2026-07-26", text: "旧作版权代理方称已启动内部评估" },
      { date: "2026-07-30", text: "评估结果未公布，词条持续跟进" },
    ],
    related: ["lin-su-luyin", "pei-qinghe-juben", "shang-yiran-tuoyi"],
  },
  {
    id: "han-sinan-jieyue",
    title: "韩司南公司解约风波汇总",
    persona: "韩司南",
    category: "business",
    tags: ["解约风波", "股权变更", "公司声明"],
    summary:
      "企业家韩司南名下公司的一则人事变动公告引发关注，随后出现「核心团队解约」的传闻。本页整理公告原文、变更记录与公司回应。",
    heat: 5896,
    date: "2026-05-26",
    updated: "2026-06-06",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20modern%20office%20corridor%20with%20warm%20amber%20light%20and%20geometric%20shadow%20patterns%2C%20cream%20and%20deep%20red%20palette%2C%20editorial%20magazine%20minimal&width=800&height=600&seq=entry-hansinan-01&orientation=landscape&nocache=true",
    body: [
      "5 月 26 日，公司发布一则管理层人事变动公告，涉及两名高管的职务调整，公告未说明具体原因。",
      "随后有财经账号称公司出现「核心团队集体解约」，并援引了未经证实的内部消息。该说法在数日内被大量转载。",
      "6 月 2 日，公司通过投资者关系渠道回应，表示公告涉及的调整属于正常轮岗，不存在团队集体离职的情况。",
      "6 月 6 日，工商信息显示相关主体的股东结构未发生实质性变化。此前的传闻未再出现新的佐证。",
    ],
    timeline: [
      { date: "2026-05-26", text: "公司发布管理层人事变动公告" },
      { date: "2026-05-29", text: "财经账号称核心团队集体解约" },
      { date: "2026-06-02", text: "公司回应称系正常轮岗" },
      { date: "2026-06-06", text: "工商信息显示股东结构未变" },
    ],
    related: ["lu-shiyan-daiyan", "jiang-yubai-shuju", "su-wantang-kouwu"],
  },
  {
    id: "wen-zhi-peiyin",
    title: "温稚配音档期争议汇总",
    persona: "温稚",
    category: "screen",
    tags: ["配音档期", "角色更换", "制作方说明"],
    summary:
      "一部动画的角色配音在播出中期发生更换，原配音演员温稚的档期问题成为讨论焦点。本页整理制作方说明与演员本人的表态。",
    heat: 5477,
    date: "2026-06-09",
    updated: "2026-06-16",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20voice%20recording%20microphone%20silhouette%20with%20warm%20amber%20backlight%20and%20cream%20paper%20texture%2C%20deep%20red%20accent%2C%20editorial%20magazine%20minimal%20artistic&width=800&height=600&seq=entry-wenzhi-01&orientation=landscape&nocache=true",
    body: [
      "6 月 9 日，动画更新至中段，观众发现某角色的声音发生变化，弹幕与评论区随即出现关于更换配音的讨论。",
      "6 月 11 日，制作方发布说明，称由于制作周期调整与演员档期冲突，自该集起由另一位配音演员接替，并对观众的支持表示感谢。",
      "6 月 13 日，温稚在个人账号回应，表示与制作方沟通良好，档期确实存在重叠，希望观众继续支持作品。",
      "6 月 16 日，接替的配音演员也发文致意。讨论逐渐转向对新声音的适应，争议基本平息。",
    ],
    timeline: [
      { date: "2026-06-09", text: "播出中段角色声音变化，引发讨论" },
      { date: "2026-06-11", text: "制作方说明系档期冲突更换配音" },
      { date: "2026-06-13", text: "温稚回应与制作方沟通良好" },
      { date: "2026-06-16", text: "接替演员发文致意，争议平息" },
    ],
    related: ["gu-yu-fanwei", "su-wantang-kouwu", "pei-qinghe-juben"],
  },
  {
    id: "pei-qinghe-juben",
    title: "裴清和剧本署名争议汇总",
    persona: "裴清和",
    category: "screen",
    tags: ["署名争议", "作品改编", "编剧回应"],
    summary:
      "编剧裴清和就一部改编剧的署名方式公开提出异议，涉及原著作者与编剧团队的排序问题。本页整理各方回应与最终处理。",
    heat: 5203,
    date: "2026-05-14",
    updated: "2026-05-23",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20stack%20of%20script%20pages%20with%20warm%20amber%20side%20light%20and%20cream%20paper%20texture%2C%20deep%20red%20accent%2C%20editorial%20magazine%20minimal%20artistic&width=800&height=600&seq=entry-peiqinghe-01&orientation=landscape&nocache=true",
    body: [
      "5 月 14 日，裴清和在个人账号发布长文，说明自己在某改编剧中的参与程度，并指出片头署名方式与前期约定存在出入。",
      "5 月 17 日，制作方回应称署名方案依据合同与行业惯例拟定，愿意就具体分歧与对方沟通。",
      "5 月 20 日，双方进行了线下沟通。当晚裴清和更新动态，表示沟通顺利，后续署名将按协商结果调整。",
      "5 月 23 日，该剧片头版本完成更新，署名方式有所调整。裴清和未再就该话题发声。",
    ],
    timeline: [
      { date: "2026-05-14", text: "裴清和发长文提出署名异议" },
      { date: "2026-05-17", text: "制作方回应称依据合同与惯例" },
      { date: "2026-05-20", text: "双方线下沟通，达成调整共识" },
      { date: "2026-05-23", text: "片头版本更新，署名已调整" },
    ],
    related: ["gu-yu-fanwei", "chi-ye-chaoxi", "wen-zhi-peiyin"],
  },
  {
    id: "bai-luchuan-zhibo",
    title: "白露川直播内容争议汇总",
    persona: "白露川",
    category: "livestream",
    tags: ["直播内容", "规则说明", "平台处理"],
    summary:
      "主播白露川在一场直播中的互动环节被指越界，平台随后给出处理说明。本页梳理事件经过、主播致歉与平台规则依据。",
    heat: 6650,
    date: "2026-07-09",
    updated: "2026-07-18",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20neon-lit%20streaming%20room%20with%20amber%20and%20deep%20red%20glow%20and%20soft%20haze%2C%20cream%20paper%20texture%2C%20editorial%20magazine%20minimal%20artistic&width=800&height=600&seq=entry-bailuchuan-01&orientation=landscape&nocache=true",
    body: [
      "7 月 9 日晚，白露川在与观众连麦互动时的一处提问方式被大量截图传播，部分观众认为内容不够妥当。",
      "7 月 10 日，直播间回放被下架，平台客服回复称相关内容正在核查。",
      "7 月 12 日，白露川发布致歉视频，表示当晚互动考虑不周，已主动联系当事观众沟通，并承诺后续加强直播间管理。",
      "7 月 18 日，平台的月度违规公示中出现了该场次记录，处理方式为限制部分互动功能一段时间。事件至此收尾。",
    ],
    timeline: [
      { date: "2026-07-09", text: "连麦互动片段被截图传播，引起讨论" },
      { date: "2026-07-10", text: "直播间回放下架，平台称正在核查" },
      { date: "2026-07-12", text: "白露川发布致歉视频并联系当事观众" },
      { date: "2026-07-18", text: "平台公示处理结果，限制部分互动功能" },
    ],
    related: ["su-wantang-kouwu", "lu-shiyan-daiyan", "shen-jiamu-jucan"],
  },
];